export default {
    fieldRequired: "Campo obrigatório",
    fieldFormatRequired: "Campo não está no formato correto",
    emailPasswordWrong: "Email ou senha incorretos",
    passwordError: "Problemas ao salvar nova senha",
    passwordWrong: "As duas senhas estão diferentes",
}
